import instance from './instance';

export const getSpecs = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/analytics/get_specs', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching specifications data:', error);
    throw error;
  }
};

export const getSignals = async ({ queryKey }) => {
  try {
    const [, spec, query] = queryKey;
    const response = await instance.get(`/v1/analytics/${spec}/get_signals`, {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching signals data:', error);
    throw error;
  }
};
